import Box from "@mui/material/Box";

// project import
import Notification from "./Notification";
import Profile from "./Profile";
/* import MobileSection from "./MobileSection"; */
/* import Localization from "./Localization"; */
/* import OrgAndSiteSelect from "./Select"; */
/* import MorePage from "./More"; */

import useConfig from "hooks/useConfig";
import { MenuOrientation } from "config";
import DrawerHeader from "ui/layout/Drawer/DrawerHeader";
import { ReactComponent as Logo } from "assets/images/icons/Logo-unity.svg";

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent({wsData}) {
  const { menuOrientation } = useConfig();

  // Render localization memoized component
 /*  const localization = useMemo(() => <Localization />, []); */

  const url = window.location.href;
  const blankKey = ["account/profile", "user_controller_invitation", "user_controller_expired", "user_controller_error", "invitation"];

  return (
    <>
      {/* Always show DrawerHeader */}
      {menuOrientation === MenuOrientation.HORIZONTAL && (
        <DrawerHeader open={true} />
      )}
      <Logo />
      <Box sx={{ display: "flex", alignItems: "center", ml: "auto", gap: "12px" }}>
       {/*  {url.includes(blankString)? '': <OrgAndSiteSelect />} */}
        {/* {localization} */}
        {/* <MorePage /> */}
        {blankKey.some(keyword => url.includes(keyword))? '': <Notification />}
        <Profile wsData={wsData}/>
      </Box>
    </>
  );
}
